export const actionTypes = {
  REQUEST_START: 'PROPERTY_OBJECTS.SAVE_TITLE.REQUEST_START',
  REQUEST_SUCCESS: 'PROPERTY_OBJECTS.SAVE_TITLE.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'PROPERTY_OBJECTS.SAVE_TITLE.REQUEST_FAILURE',
};

export function startRequest(id, data) {
  return {
    type: actionTypes.REQUEST_START,
    payload: {
      id,
      data,
    },
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
